module.exports = __webpack_public_path__ + "static/media/WATCH-BNB-APE.4e730f17.svg";